module.exports = __webpack_public_path__ + "static/img/logo-light.babfdde1.svg";